<template>
  <div class="import-source-stage" v-if="!postSending">
    <div class="import-source-stage__col">
      <app-panel title="Основной отчет">
        <div class="import-source-stage__panel-content">
          <div class="import-source-stage__panel-file import-source-stage__panel-col">
            <div class="import-source-stage__no-file-error" v-if="mainFileError">
              Выберите файл
            </div>

            <vs-upload
                    action="#"
                    :limit="1"
                    :show-upload-button="false"
                    text="Добавить файл"
                    @change="onMainReportFileChange"
                    @on-delete="onMainReportFileDelete"
                    class="import-source-stage__uploader import-source-stage__uploader_single"
                    ref="mainUploader"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="import-source-stage__panel-settings import-source-stage__panel-col">

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер листа с оплатами (нумерация с 0)"
                         vtype="uint"
                         v-model="mainReportBody.payments_list"
                         :danger.sync="mainReportErrors.payments_list"
                         danger-text="Заполните номер листа с оплатами"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер листа с начислениями (лист 'Квитанции')"
                         vtype="uint"
                         v-model="mainReportBody.charges_list"
                         :danger.sync="mainReportErrors.charges_list"
                         danger-text="Заполните номер листа с начислениями"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер листа с индивидуальными счетчиками"
                         vtype="uint"
                         v-model="mainReportBody.counters_list"
                         :danger.sync="mainReportErrors.counters_list"
                         danger-text="Заполните номер листа с счетчиками"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер листа с льготниками"
                         vtype="uint"
                         v-model="mainReportBody.privileges_list"
                         :danger.sync="mainReportErrors.privileges_list"
                         danger-text="Заполните номер листа с льготниками"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер листа с аккаунтами"
                         vtype="uint"
                         v-model="mainReportBody.accounts_list"
                         :danger.sync="mainReportErrors.accounts_list"
                         danger-text="Заполните номер листа с аккаунтами"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер листа с квартирами"
                         vtype="uint"
                         v-model="mainReportBody.flats_list"
                         :danger.sync="mainReportErrors.flats_list"
                         danger-text="Заполните номер листа с квартирами"
              />
            </div>
          </div>
        </div>
      </app-panel>
    </div>
    <div class="import-source-stage__col">
      <app-panel title="Отчет по счетчикам" flex>
        <div slot="actions" class="house-importer-import-source-stage-multiple-charges">
          <label class="app-input__label">Паркинг</label>
          <vs-switch v-model="is_parking"/>
        </div>
        <div class="import-source-stage__panel-content">
          <div class="import-source-stage__panel-file import-source-stage__panel-col">
            <div class="import-source-stage__no-file-error" v-if="counterFileError">
              Выберите файл
            </div>

            <vs-upload
                    action="#"
                    :limit="1"
                    :show-upload-button="false"
                    text="Добавить файл"
                    @change="onCounterReportFileChange"
                    @on-delete="onCounterReportFileDelete"
                    class="import-source-stage__uploader import-source-stage__uploader_single"
                    ref="counterUploader"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="import-source-stage__panel-settings import-source-stage__panel-col">
            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер столбца с которого начинается первый блок с информацией о приборах"
                         vtype="uint"
                         v-model="counterReportBody.first_block"
                         :danger.sync="counterReportErrors.first_block"
                         danger-text="Заполните номер столбца"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Длина блока с информацией об одном приборе"
                         vtype="uint"
                         v-model="counterReportBody.block_length"
                         :danger.sync="counterReportErrors.block_length"
                         danger-text="Заполните номер столбца"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер первой строки с информацией о приборах"
                         vtype="uint"
                         v-model="counterReportBody.data_start_row"
                         :danger.sync="counterReportErrors.data_start_row"
                         danger-text="Заполните номер столбца"
              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер строки с названиями типов приборов"
                         vtype="uint"
                         v-model="counterReportBody.device_type_row"
                         :danger.sync="counterReportErrors.device_type_row"
                         danger-text="Заполните номер столбца"
              />
            </div>
          </div>
        </div>
      </app-panel>
    </div>
    <div class="import-source-stage__col">
      <app-panel title="Отчет по начислениям" flex>
        <div slot="actions" class="house-importer-import-source-stage-multiple-charges">
          <label class="app-input__label">Начисления в отдельных файлах</label>
          <vs-switch v-model="multiple_charges_flag"/>
        </div>

        <div class="import-source-stage__panel-content" v-if="multiple_charges_flag">
          <div class="import-source-stage__panel-file import-source-stage__panel-col">
            <div style="text-align: center; line-height: 1.1; font-size: 12px; text-transform: uppercase; color: rgba(var(--app-warning), 1);">
              Внимание! Имя файла должно иметь формат YYYY-MM.xlsx
            </div>

            <div class="import-source-stage__no-file-error" v-if="chargesFilesError">
              Выберите хотя бы один файл
            </div>

            <vs-upload
                    action="#"
                    :limit="72"
                    :show-upload-button="false"
                    :multiple="true"
                    text="Добавить файлы"
                    class="w-auto mx-auto import-source-stage__uploader import-source-stage__uploader_charges"
                    @change="onChargesFileChange"
                    @on-delete="onChargesFileDelete"
                    ref="chargesUploader"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="import-source-stage__panel-settings import-source-stage__panel-col">
            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер строки с названиями тарифов(нумерация с 0)"
                         vtype="uint"
                         v-model="chargesReportBody.tarifs_row"
                         :danger.sync="chargesReportErrors.tarifs_row"
                         danger-text="Заполните номер строки"

              />
            </div>

            <div class="import-source-stage__panel-settings-row">
              <app-input label="Номер первой колонки с начислениями"
                         vtype="uint"
                         v-model="chargesReportBody.first_tarif_col"
                         :danger.sync="chargesReportErrors.first_tarif_col"
                         danger-text="Заполните номер строки"
              />
            </div>
          </div>
        </div>
      </app-panel>
    </div>
    <div class="import-source-stage__send-button">
      <app-button color="success" @click="sendSourceImport">Отправить</app-button>
    </div>
  </div>
  <div v-else-if="postSending" class="content-full-page import-source-stage-post-sending" >
    <div class="block-loading" />
    {{importInfo.status ? importInfo.status : 'Импортируем файлы...'}}
  </div>
</template>

<script>
  export default {
    name: "ImportSourceStageMain",
    props: {
      importId: {
        type: Number,
        required: true
      },
      importInfo: {}
    },
    data() {
      return {
        multiple_charges_flag: false,
        is_parking: false,
        mainReportFile: null,
        mainReportBody: {
          payments_list: null,
          charges_list: null,
          counters_list: null,
          privileges_list: null,
          accounts_list: null,
          flats_list: null
        },
        mainReportErrors: {
          payments_list: false,
          charges_list: false,
          counters_list: false,
          privileges_list: false,
          accounts_list: false,
          flats_list: false
        },
        mainFileError: false,
        counterReportFile: null,
        counterReportBody: {
          first_block: null,
          block_length: null,
          data_start_row: null,
          device_type_row: null
        },
        counterReportErrors: {
          first_block: false,
          block_length: false,
          data_start_row: false,
          device_type_row: false
        },
        counterFileError: false,
        chargesFiles: [],
        chargesReportBody: {
          tarifs_row: null,
          first_tarif_col: null,
        },
        chargesReportErrors: {
          tarifs_row: false,
          first_tarif_col: false,
        },
        chargesFilesError: false,
        postSending: false,
      }
    },
    computed: {
      mainReportErrorsHasErrors() {
        return !!Object.values(this.mainReportErrors).filter(v => v).length;
      },
      counterReportErrorsHasErrors() {
        return !!Object.values(this.counterReportErrors).filter(v => v).length;
      },
      chargesReportErrorsHasErrors() {
        return !!Object.values(this.chargesReportErrors).filter(v => v).length;
      },
      hasAnyErrors() {
        return this.mainReportErrorsHasErrors ||
            this.counterReportErrorsHasErrors ||
            this.chargesReportErrorsHasErrors ||
            this.counterFileError ||
            this.mainFileError ||
            this.chargesFilesError;
      }
    },
    methods: {
      resetAllErrors() {
        this.resetMainReportErrors();
        this.resetCounterReportErrors();
        this.resetChargesReportErrors();
      },
      resetAllBodies() {
        this.resetMainReportBody();
        this.resetCounterReportBody();
        this.checkChargesReportBody();
      },
      resetAllFiles(){
        this.chargesFiles = [];
        this.counterReportFile = null;
        this.mainReportFile = null;
      },

      checkMainReportBody() {
        if (this.mainReportFile === null) {
          this.mainFileError = true;
        }


        if (this.mainReportBody.payments_list === null) {
          this.mainReportErrors.payments_list = true;
        }

        if (this.mainReportBody.charges_list === null) {
          this.mainReportErrors.charges_list = true;
        }

        if (this.mainReportBody.counters_list === null) {
          this.mainReportErrors.counters_list = true;
        }

        if (this.mainReportBody.privileges_list === null) {
          this.mainReportErrors.privileges_list = true;
        }

        if (this.mainReportBody.accounts_list === null) {
          this.mainReportErrors.accounts_list = true;
        }

        if (this.mainReportBody.flats_list === null) {
          this.mainReportErrors.flats_list = true;
        }
      },
      resetMainReportBody() {
        Object.assign(this.mainReportBody, {
          payments_list: null,
          charges_list: null,
          counters_list: null,
          privileges_list: null,
          accounts_list: null,
          flats_list: null
        });
        this.resetMainFile();
      },
      resetMainReportErrors() {
        Object.assign(this.mainReportErrors, {
          payments_list: false,
          charges_list: false,
          counters_list: false,
          privileges_list: false,
          accounts_list: false,
          flats_list: false
        });
        this.chargesFilesError = false;
      },
      resetMainFile() {
        this.mainReportFile = null;
        this.$refs.mainUploader.srcs = [];
        this.$refs.mainUploader.itemRemove = [];
        this.$refs.mainUploader.filesx = [];
      },

      checkCounterReportBody() {
        if (this.counterReportFile === null) {
          this.counterFileError = true;
        }

        if (this.counterReportBody.first_block === null) {
          this.counterReportErrors.first_block = true;
        }

        if (this.counterReportBody.block_length === null) {
          this.counterReportErrors.block_length = true;
        }

        if (this.counterReportBody.data_start_row === null) {
          this.counterReportErrors.data_start_row = true;
        }

        if (this.counterReportBody.device_type_row === null) {
          this.counterReportErrors.device_type_row = true;
        }
      },
      resetCounterReportBody() {
        Object.assign(this.mainReportBody, {
          first_block: null,
          block_length: null,
          data_start_row: null,
          device_type_row: null
        });
        this.resetCounterFile();
      },
      resetCounterReportErrors() {
        Object.assign(this.counterReportErrors, {
          first_block: false,
          block_length: false,
          data_start_row: false,
          device_type_row: false
        });
        this.counterFileError = false;
      },
      resetCounterFile() {
        this.counterReportFile = null;
        this.$refs.counterUploader.srcs = [];
        this.$refs.counterUploader.itemRemove = [];
        this.$refs.counterUploader.filesx = [];
      },

      checkChargesReportBody() {
        if (!this.chargesFiles.length) {
          this.chargesFilesError = true;
        }

        if (this.chargesReportBody.tarifs_row === null) {
          this.chargesReportErrors.tarifs_row = true;
        }

        if (this.chargesReportBody.first_tarif_col === null) {
          this.chargesReportErrors.first_tarif_col = true;
        }
      },
      resetChargesReportBody() {
        Object.assign(this.chargesReportBody, {
          tarifs_row: null,
          first_tarif_col: null,
        });
        this.resetChargesFiles();
      },
      resetChargesReportErrors() {
        Object.assign(this.chargesReportErrors, {
          tarifs_row: false,
          first_tarif_col: false,
        });
        this.chargesFilesError = false;
      },
      resetChargesFiles() {
        this.chargesFiles = [];
        this.$nextTick(() => {
          if (this.$refs.chargesUploader) {
            this.$refs.chargesUploader.srcs = [];
            this.$refs.chargesUploader.itemRemove = [];
            this.$refs.chargesUploader.filesx = [];
          }

        });

      },

      onMainReportFileChange(value, files) {
        this.mainReportFile = files.filter(file => !file.remove)[0] || null;
        this.mainFileError = false;
      },
      onMainReportFileDelete() {
        this.mainReportFile = null;
        this.mainFileError = false;
      },
      onCounterReportFileChange(value, files) {
        this.counterReportFile = files.filter(file => !file.remove)[0] || null;
        this.counterFileError = false;
      },
      onCounterReportFileDelete() {
        this.counterReportFile = null;
        this.counterFileError = false;
      },
      onChargesFileChange(value, files) {
        this.chargesFiles = files.filter(file => !file.remove);
        this.chargesFilesError = false;
      },
      onChargesFileDelete(file) {
        const index = this.chargesFiles.indexOf(file);
        if (index > -1) {
          this.chargesFiles.splice(index, 1);
          this.chargesFilesError = false;
        }
      },

      async sendSourceImport() {
        this.resetAllErrors();
        this.checkMainReportBody();

        if (!this.is_parking) {
          this.checkCounterReportBody();
        }

        if (this.multiple_charges_flag) {
          this.checkChargesReportBody();
        }

        if (this.hasAnyErrors) return false;


        let body = Object.assign({}, this.mainReportBody,
            this.counterReportBody,
            {
              import_id: this.importId,
              main_report: this.mainReportFile,
              counters_report: this.counterReportFile,
              is_parking: this.is_parking,
              multiple_charges_flag: this.multiple_charges_flag
            }
        );

        if (this.multiple_charges_flag) {
          Object.assign(body, this.chargesReportBody, {multiple_charges: this.chargesFiles});
        }



        let bodyFormData = new FormData();

        for(let key in body){
          if(body.hasOwnProperty(key)){
            if(Array.isArray(body[key])){
              for(let i = 0; i < body[key].length; i++){
                bodyFormData.append(`${key}[${i}]`, body[key][i]);
              }
            }
            else{
              bodyFormData.append(key, body[key])
            }
          }
        }

        try{
          this.postSending = true;

          let {data} = await this.$http.post('import/houses/stage_1', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });

          if(data === 'done'){
            this.$router.replace({
              params: {
                stage: 1,
                id: this.importId
              }
            })
          }
          else{
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
        finally{
          this.postSending = false;
          this.resetAllFiles();
        }
      }
    },

    watch: {
      multiple_charges_flag() {
        this.resetChargesReportErrors();
        this.resetChargesReportBody();
      }
    }
  }
</script>

<style lang="scss">
  .import-source-stage {
    display: flex;
    flex-wrap: wrap;
    margin: -7.5px;

    &__send-button {
      position: fixed;
      right: 15px;
      bottom: 15px;
    }

    &__col {
      flex: 1 1 50%;
      max-width: 50%;
      padding: 7.5px;

      & > .app-panel {
        height: 100%;

        .app-panel__body {
          height: calc(100% - 71px);
        }
      }

      &_b {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }

    &__no-file-error {
      text-align: center;
      font-size: 11px;
      text-transform: uppercase;
      color: rgba(var(--app-danger), 1);
      font-weight: 600;
    }

    &__panel-content {
      display: flex;
      /*align-items: center;*/
      margin: 0 -7.5px;
      height: 100%;
    }

    &__panel-col {
      padding: 0 7.5px;
    }

    &__panel-file {
      border-right: 1px solid rgba(0, 0, 0, .2);

      flex-shrink: 0;
      flex-basis: 40%;
      display: flex;
      flex-direction: column;
    }

    &__panel-settings {
      flex: 1;

      &-row {
        margin-bottom: 15px;
      }
    }

    &__uploader {
      &_single {
        width: 100%;
        height: 100%;

        .con-img-upload {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .img-upload {
            border-radius: 10px;
            box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
            border: 1px solid rgba(0, 0, 0, .2);

            .text-archive span {
              font-size: 16px;
              word-break: break-all;
            }
          }
        }
      }

      &_charges {
        .con-img-upload {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;

          .img-upload {

            margin: 5px;
            width: 100px;
            height: 100px;
            border-radius: 10px;
            box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
            border: 1px solid rgba(0, 0, 0, .2);

            .text-archive {
              i {
                font-size: 5rem;
              }

              span {
                font-size: 12px;
                word-break: break-all;
              }
            }
          }
        }

        .con-input-upload {
          width: 100px;
          height: 100px;
          margin: 5px;

          .text-input {
            font-size: 12px;
            min-width: 100px;
            line-height: 1.1;
          }
        }
      }
    }

  }

  .house-importer-import-source-stage-multiple-charges {
    display: flex;

    .app-input__label {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }

  .import-source-stage-post-sending{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading{
      width: 100px;
      height: 100px;
      flex: 0;
      margin-bottom: 15px;
    }
  }
</style>
